import React from 'react'
import YouTube from 'react-youtube'
import styles from './YouTubeVideo.module.css'

export default function YouTubeVideo({ videoId, style = {} }) {
  const opts = {
    height: '390px',
    width: '100%',
    containerClassName: styles.container,
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
    },
  }

  return <YouTube videoId={videoId} opts={opts} style={style} />
}
